import { translate, useLocale } from "../localization";
import React, { useState } from "react";
import { AppButton } from "./ui";
import "./SortToggleButton.scss";

const SortToggleButton = ({ attribute, sortFunction, activeSort }) => {
  useLocale();
  // State to track sort order: true for ascending, false for descending
  const [ascending, setAscending] = useState(true);

  const handleClick = () => {
    const newAscending = !ascending;
    // Toggle the sort order and sort the sessions
    setAscending(newAscending);
    sortFunction(attribute, newAscending);
  };

  const isActive = activeSort && activeSort.attribute === attribute;

  return (
    <AppButton
      className={`sort-toggle-button ${isActive ? "active" : ""}`}
      onClick={handleClick}
      type="button"
      kind="ghost"
      aria-label={translate("Sort by {value0} in {value1} order", {
  value0: attribute,
  value1: !ascending ? "descending" : "ascending"
})}
    >
      {ascending ? "↓" : "↑"}
    </AppButton>
  );
};

export default SortToggleButton;
